import { axiosInstance } from "../../axios/axios";

export const getTerrainsApi = async (token) => {
    return await axiosInstance.get('/api/company/terrains', {
        headers: {
            Authorization: 'Bearer ' + token,
        }
    })
    .then(function (response) {
        if (response?.data?.errors) {
            return response?.data
        }
        return response
    })
    .catch(function (error) {
        return error.response
    })
}

export const storeTerrainApi = async (token, terrainData) => {
    return await axiosInstance.post('/api/company/terrains', terrainData, {
        headers: {
            Authorization: 'Bearer ' + token,
        }
    })
    .then(function (response) {
        if (response?.data?.errors) {
            return response?.data
        }
        return response
    })
    .catch(function (error) {
        return error.response
    })
}

export const deleteTerrainApi = async (token, terrainId) => {
    return await axiosInstance.delete(`/api/company/terrains/${terrainId}`, {
        headers: {
            Authorization: 'Bearer ' + token,
        }
    })
    .then(function (response) {
        if (response?.data?.errors) {
            return response?.data
        }
        return response
    })
    .catch(function (error) {
        return error.response
    })
}

export const getTerrainApi = async (token, terrainId) => {
    return await axiosInstance.get(`/api/company/terrains/${terrainId}`, {
        headers: {
            Authorization: 'Bearer ' + token,
        }
    })
    .then(function (response) {
        if (response?.data?.errors) {
            return response?.data
        }
        return response
    })
    .catch(function (error) {
        return error.response
    })
}

export const postTerrainStaffApi = async (token, terrainId, staffData) => {
    return await axiosInstance.post(`/api/company/terrains/${terrainId}/staff`, staffData, {
        headers: {
            Authorization: 'Bearer ' + token,
        }
    })
    .then(function (response) {
        if (response?.data?.errors) {
            return response?.data
        }
        return response
    })
    .catch(function (error) {
        return error.response
    })
}

export const getTerrainPlanningApi = async (token, params) => {
    return await axiosInstance.get('/api/company/terrains_planning', {
        headers: {
            Authorization: 'Bearer ' + token,
        },
        params: params
    })
    .then(function (response) {
        if (response?.data?.errors) {
            return response?.data
        }
        return response
    })
    .catch(function (error) {
        return error.response
    })
}

export const getTerrainsAssessmentApi = async (token, params) => {
    return await axiosInstance.get('/api/company/terrains_assessment', {
        headers: {
            Authorization: 'Bearer ' + token,
        },
        params: params
    })
    .then(function (response) {
        if (response?.data?.errors) {
            return response?.data
        }
        return response
    })
    .catch(function (error) {
        return error.response
    })
}

export const getTerrainsStaffMatchingApi = async (token, params) => {
    return await axiosInstance.get('/api/company/terrains_staff_matching', {
        headers: {
            Authorization: 'Bearer ' + token,
        },
        params: params
    })
    .then(function (response) {
        if (response?.data?.errors) {
            return response?.data
        }
        return response
    })
    .catch(function (error) {
        return error.response
    })
}

export const postTerrainsAutoStaffMatchingApi = async (token, params) => {
    return await axiosInstance.post('/api/company/terrains_auto_staff_matching', params, {
        headers: {
            Authorization: 'Bearer ' + token,
        }
    })
    .then(function (response) {
        if (response?.data?.errors) {
            return response?.data
        }
        return response
    })
    .catch(function (error) {
        return error.response
    })
}

export const postTerrainsStaffConfirmationApi = async (token, params) => {
    return await axiosInstance.post('/api/company/terrains_staff_confirmation', params, {
        headers: {
            Authorization: 'Bearer ' + token,
        }
    })
    .then(function (response) {
        if (response?.data?.errors) {
            return response?.data
        }
        return response
    })
    .catch(function (error) {
        return error.response
    })
}

export const postTerrainsAutoStaffMatchingTrackingApi = async (token, params) => {
    return await axiosInstance.post('/api/company/terrains_auto_staff_matching/tracking', params, {
        headers: {
            Authorization: 'Bearer ' + token,
        }
    })
    .then(function (response) {
        if (response?.data?.errors) {
            return response?.data
        }
        return response
    })
    .catch(function (error) {
        return error.response
    })
}

export const postTalentAssessmentActionApi = async (token, params) => {
    return await axiosInstance.post('/api/terrain/assessment/action', params, {
        headers: {
            Authorization: 'Bearer ' + token,
        }
    })
    .then(function (response) {
        if (response?.data?.errors) {
            return response?.data
        }
        return response
    })
    .catch(function (error) {
        return error.response
    })
}

export const postTerrainStatsDailyApi = async (token, params) => {
    return await axiosInstance.post('/api/terrain/stats/daily', params, {
        headers: {
            Authorization: 'Bearer ' + token,
        }
    })
    .then(function (response) {
        if (response?.data?.errors) {
            return response?.data
        }
        return response
    })
    .catch(function (error) {
        return error.response
    })
}

export const postTerrainStaffAddApi = async (token, staffData) => {
    return await axiosInstance.post('/api/terrain/staff/add', staffData, {
        headers: {
            Authorization: 'Bearer ' + token,
        }
    })
    .then(function (response) {
        if (response?.data?.errors) {
            return response?.data
        }
        return response
    })
    .catch(function (error) {
        return error.response
    })
}
